module.exports = __webpack_public_path__ + "66ffcb4d9190b8c705e967a57fd82797.jpg";